import { useWindowOpen } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { Banner } from '@zenterprise-inc/ui';

import BznavCareIcon from '@/assets/alliance/bg/BznavCareIcon.svg';
import { 비즈넵케어신청완료링크 } from '@/lib/constants/link';

export const ApplyCompleteBanner = () => {
  const { openWindow } = useWindowOpen();
  const { sendClickEvent } = useUserEventLogger();

  const handleClick = () => {
    openWindow(비즈넵케어신청완료링크, '_system');

    sendClickEvent('corps-request_apply-complete_refund.ads', {
      ads: 'bznav-care'
    });
  };

  return (
    <div className="page-padding w-full max-w-[520px]">
      <Banner.RightAction
        color="violet"
        title="환급금이 있었다면, 세무 기장 필수!"
        subText="월 3만원으로 해결하기"
        illustIcon={<BznavCareIcon />}
        onClick={handleClick}
        className="w-full cursor-pointer"
      />
    </div>
  );
};
